import { render, staticRenderFns } from "./YdStockMerchant.vue?vue&type=template&id=98939762"
import script from "./YdStockMerchant.vue?vue&type=script&lang=js"
export * from "./YdStockMerchant.vue?vue&type=script&lang=js"
import style0 from "./YdStockMerchant.vue?vue&type=style&index=0&id=98939762&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports